import { useSelector } from 'react-redux'
import EClaimForm from '../EClaimDetail/EClaimForm'
import { RootState } from '../../redux-store'
import styled from '@emotion/styled'
import Breadcrumb from '../../components/common/Breadcrumb'
import EClaimInfo from '../EClaimDetail/EClaimInfo'
import { useRouter } from '../../utils/helper'
import { useGetEClaimById } from '../../services/e-claim/e-claim-query'
import { home } from '../../constant/path'
import { pullAt } from 'lodash'
import { useScreen } from '../../utils/responsive-helper'

const BreadcrumbContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`

const EClaimSummary = () => {
  const { query } = useRouter<{ eClaimId: number }>()
  const { isMobile } = useScreen()
  const { data: eClaimItem } = useGetEClaimById({ claimId: query.eClaimId })

  const eClaimFormValue = useSelector((state: RootState) => state.eClaim.claimInfo)

  return (
    <>
      {!isMobile && (
        <BreadcrumbContainer>
          <Breadcrumb
            overide={(paths) => {
              paths.unshift({
                label: 'Home',
                path: home(),
              })
              pullAt(paths, 2)
              paths[1].label = 'ปรับเปลี่ยนสวัสดิการ'
              paths[2].label = `${eClaimItem?.claimName}`
              paths[3].label = 'ยื่นคำขอ'

              return paths
            }}
          />
        </BreadcrumbContainer>
      )}

      <EClaimInfo eClaimItem={eClaimItem} hideDetail />

      <EClaimForm
        eClaimItem={eClaimItem}
        eClaimFormValue={eClaimFormValue}
        editable={false}
        isPreview={true}
      />
    </>
  )
}

export default EClaimSummary
